var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3090_38107",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3090_38107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0007 13.25L26.0007 17C26.209 17.1527 26.3722 17.3472 26.4902 17.5833C26.6083 17.8194 26.6673 18.0694 26.6673 18.3333V25.8333C26.6673 26.2916 26.5041 26.684 26.1777 27.0104C25.8513 27.3368 25.459 27.5 25.0007 27.5H15.0007C14.5423 27.5 14.15 27.3368 13.8236 27.0104C13.4972 26.684 13.334 26.2916 13.334 25.8333V18.3333C13.334 18.0694 13.393 17.8194 13.5111 17.5833C13.6291 17.3472 13.7923 17.1527 14.0007 17L19.0007 13.25C19.2923 13.0277 19.6257 12.9166 20.0007 12.9166C20.3757 12.9166 20.709 13.0277 21.0007 13.25ZM20.0007 22.5C20.6951 22.5 21.2854 22.2569 21.7715 21.7708C22.2576 21.2847 22.5007 20.6944 22.5007 20C22.5007 19.3055 22.2576 18.7152 21.7715 18.2291C21.2854 17.743 20.6951 17.5 20.0007 17.5C19.3062 17.5 18.7159 17.743 18.2298 18.2291C17.7437 18.7152 17.5007 19.3055 17.5007 20C17.5007 20.6944 17.7437 21.2847 18.2298 21.7708C18.7159 22.2569 19.3062 22.5 20.0007 22.5ZM20.0007 20.8333C19.7645 20.8333 19.5666 20.7534 19.4069 20.5937C19.2472 20.434 19.1673 20.2361 19.1673 20C19.1673 19.7638 19.2472 19.5659 19.4069 19.4062C19.5666 19.2465 19.7645 19.1666 20.0007 19.1666C20.2368 19.1666 20.4347 19.2465 20.5944 19.4062C20.7541 19.5659 20.834 19.7638 20.834 20C20.834 20.2361 20.7541 20.434 20.5944 20.5937C20.4347 20.7534 20.2368 20.8333 20.0007 20.8333ZM20.0007 25C19.4312 25 18.8757 25.0694 18.334 25.2083C17.7923 25.3472 17.2784 25.5555 16.7923 25.8333H23.209C22.7229 25.5555 22.209 25.3472 21.6673 25.2083C21.1257 25.0694 20.5701 25 20.0007 25ZM15.0007 18.3333V25C15.7229 24.4583 16.5076 24.0451 17.3548 23.7604C18.202 23.4757 19.084 23.3333 20.0007 23.3333C20.9173 23.3333 21.7993 23.4757 22.6465 23.7604C23.4937 24.0451 24.2784 24.4583 25.0007 25V18.3333L20.0007 14.5833L15.0007 18.3333Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateCompany);
export default __webpack_public_path__ + "static/media/privateCompany.00384cde32c7a081e596adf862bf1ec5.svg";
export { ForwardRef as ReactComponent };